import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-dot-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      [attr.fill]="fill()"
      [class]="iconClass()">
      <path
        d="M1.66667 0C0.746667 0 0 0.746667 0 1.66667C0 2.58667 0.746667 3.33333 1.66667 3.33333C2.58667 3.33333 3.33333 2.58667 3.33333 1.66667C3.33333 0.746667 2.58667 0 1.66667 0Z"
        [attr.fill]="fill()" />
    </svg>
  `,
})
export class DotIconComponent extends BaseIconComponent {
  override width = input<string>('0.75rem');
  override height = input<string>('0.75rem');
  override viewBox = input<string>('0 0 4 4');
  override fill = input<string>('currentColor');
}
